// PageTime Component
/* eslint react/jsx-handler-names:off */

import React from 'react'
import async from 'async'
import _ from 'lodash'
import moment from 'moment'
import { DragDropContext as dragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import TimeUtil from '../../../lib/timeutil.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import DialogTimeCardDetail from '../../dialog/dialog_timecard_detail/dialog_timecard_detail.jsx'
import DialogTimeCardAdd from '../../dialog/dialog_timecardadd/dialog_timecardadd.jsx'
import DialogConfirm from '../../../theme/dialog/dialog_confirm/dialog_confirm.jsx'
import TimeList from '../../time/time_list/time_list.jsx'
import TimeAddItem from '../../time/time_additem/time_additem.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Util from '../../../lib/util.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Acl from '../../../lib/acl.jsx'
import PageHeaderTime from '../../../theme/layout/page_headertime/page_headertime.jsx'
import DateRangePicker from '../../../theme/common/daterange_picker/daterange_picker.jsx'
import FavouriteList from '../../time/favourite_list/favourite_list.jsx'
import { buildTimerEvents } from '../../../../shared/util/timer/timerEvents.js'
import { TimeIcon } from '../../../common/layout/menu_icons/time.jsx'

@dragDropContext(HTML5Backend)
class PageTime extends PageBase {
  constructor (props) {
    super(props, 'time', 'time', 'time')

    this.state = {
      loading: true
    }

    this.data = {
      editTimeCardId: props.activeTimeCardId || null,
      favourites: [],
      timeCards: [],
      projects: [],
      activities: [
        { label: 'time.form.labelHoliday', value: 'Holidays' },
        { label: 'time.form.labelSickLeave', value: 'Sick Leave' },
        { label: 'time.form.labelMeeting', value: 'Meeting' },
        { label: 'time.form.labelTraining', value: 'Training' },
        { label: 'time.form.labelDoctor', value: 'Doctor/ Dentist' },
        { label: 'time.form.labelOther', value: 'Other' }
      ],
      stat: null,
      pageState: {
        filter: {
          member: {
            label: '',
            value: props.activeUserId || app.loggedInId
          }
        }
      },
      userName: app.loggedInUserTeam.displayName,
      activeTimeCard: null,
      weekStats: [],
      bEditFavourite: false,
      fromDate: null,
      toDate: null,
      confirmTaskCallback: null
    }

    // TODO: Process props.weekNo
    const currDate = DateUtil.getUTCCurrentDate()
    const weekNo = props.weekNo
    let activeDate =
      props.activeTimeDate ||
      new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate())
    if (weekNo && weekNo > 0) {
      // Get the start date of the week and start of the day
      activeDate = moment(currDate)
        .isoWeek(weekNo)
        .startOf('day')
        .toDate()
    }

    this._calculateFromToDates(activeDate)

    this._setFABButtonState(true, true)
    this.showFabButton = true
    this._bUnMounted = false
    this._references = {
      dialogTimeCardDetail: React.createRef(),
      dialogTimeCardAdd: React.createRef(),
      timeItemAdd: React.createRef(),
      pageHeaderCalendar: React.createRef(),
      dialogConfirm: React.createRef()
    }
  }

  componentDidMount () {
    this._getData(false)
    this._initEvents()

    if (this.props.showAdd && this._references.dialogTimeCardAdd.current) {
      this.data.confirmTaskCallback = null
      this._references.dialogTimeCardAdd.current.show()
    }
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  renderContent () {
    const { timeCards, editTimeCardId, bEditFavourite, pageState } = this.data
    const loading = this.state.loading
    const timer = this._getTimer()
    const filter = pageState.filter

    let bCurUser = true
    if (filter.member && filter.member.value !== app.loggedInId) {
      bCurUser = false
    }

    let bIgnoreTimer = false
    if (filter.member && filter.member.value !== app.loggedInId) {
      bIgnoreTimer = true
    }

    return (
      <div className='pageinnercont'>
        {!loading && (
          <TimeList
            timeCards={timeCards}
            editTimeCardId={editTimeCardId}
            loggedInId={app.loggedInId}
            timer={timer}
            bMessageIgnoreTimer={bIgnoreTimer}
            canDrop={!bEditFavourite}
            onSave={this._onUpdateTimeCard.bind(this)}
            onUpdateFavorite={this._onUpdateFavorite.bind(this)}
            onOpenForm={this._onOpenTimeEditForm.bind(this, true)}
            onCloseForm={this._onCloseTimeEditForm.bind(this)}
            onDelete={this._onDeleteTimeCard.bind(this)}
            onTimerStart={this._onTimerStart.bind(this)}
            onTimerPause={this._onTimerPause.bind(this)}
            onTimerFinalize={this._onTimerFinalize.bind(this)}
            onShowDetailForm={this._onShowDetailForm.bind(this)}
            onDrop={this._onDropFavouriteItem.bind(this)}
            onMessageAdd={this._onAddManualTimeCard.bind(this)}
            onMessageStart={this._onAddTimer.bind(this)}
            onTimerStop={this._onTimerStop.bind(this)}
            onShowError={this._onShowMaxTimeError.bind(this)}
            stopAndCreateNewTimeCard={this._stopAndCreateNewTimeCard.bind(this)}
          />
        )}
        {this._renderAddItem()}
        <DialogTimeCardDetail
          ref={this._references.dialogTimeCardDetail}
          showDelete
          projects={this.data.projects}
          getActivities={TimeUtil.onSearchActivity}
          getTasks={TimeUtil.onGetTasks}
          onUpdateDetail={this._onUpdateTimeCardDetail.bind(this)}
          onFinalize={this._onFinalizeTimeCard.bind(this)}
          onDelete={this._onDeleteTimeCardDetail.bind(this)}
        />
        <DialogTimeCardAdd
          ref={this._references.dialogTimeCardAdd}
          projects={this.data.projects}
          currentUser={bCurUser || Acl.isRoleProjectManager()}
          getTasks={TimeUtil.onGetTasks}
          onSubmit={this._onSubmitAddTimeCard.bind(this)}
          onSearchActivity={TimeUtil.onSearchActivity}
          onConfirmOutsideDate={this._onConfirmOutsideDate}
        />
        <DialogConfirm
          ref={this._references.dialogConfirm}
          title='time.dialog.dialogTitle'
          message='time.dialog.dialogTitle'
          labelOk='common.common.confirmYesButton'
          labelCancel='common.common.confirmNoButton'
          showOk
          showCancel
          onClickOk={this._onConfirmOk}
          onClickNo={this._onConfirmCancel}
        />
      </div>
    )
  }

  getContentClassname () {
    return 'alt'
  }

  /* Event handlers */
  onAdd () {
    if (this._references.timeItemAdd.current) {
      this._references.timeItemAdd.current.show()
    }
  }

  onFABClose () {
    if (this._references.timeItemAdd.current) {
      this._references.timeItemAdd.current.hide()
    }
  }

  _onDropFavouriteItem (favouriteItem) {
    const createData = Util.removeObjectKeys(_.cloneDeep(favouriteItem), [
      'id',
      'project',
      'timeCardIds',
      'timeTaken',
      'description',
      'index',
      'customActivityType',
      'orderNumber',
      'task'
    ])

    this._onCreateTimeCard(createData, false, () => { })
  }

  _onShowMaxTimeError () {
    this.showError('time.form.timeErrorLabel')
  }

  _onConfirmOk = () => {
    if (this.data.confirmTaskCallback) {
      this.data.confirmTaskCallback()
    }

    if (this._references.dialogConfirm.current) {
      this._references.dialogConfirm.current.hide()
    }
  }

  _onConfirmCancel = () => {
    this.data.confirmTaskCallback = null

    if (this._references.dialogConfirm.current) {
      this._references.dialogConfirm.current.hide()

      if (this._references.dialogTimeCardAdd.current) {
        this._references.dialogTimeCardAdd.current.hide()
      }
    }
  }

  _onConfirmOutsideDate = (message, callback) => {
    this.data.confirmTaskCallback = callback
    if (this._references.dialogConfirm.current) {
      this._references.dialogConfirm.current.showMessage(message)
    }
  }

  _onSubmitAddTimeCard (timeCard, bOpen) {
    this._onCreateTimeCard(timeCard, false, () => {
      this.showFabButton = !bOpen

      if (this._references.dialogTimeCardAdd.current) {
        this._references.dialogTimeCardAdd.current.hide()

        if (bOpen) {
          this._references.dialogTimeCardAdd.current.show()
        }
      }
    })
  }

  _onAddManualTimeCard () {
    if (this._references.timeItemAdd.current) {
      this._references.timeItemAdd.current.hide()
    }

    if (this._references.dialogTimeCardAdd.current) {
      this.data.confirmTaskCallback = null
      this._references.dialogTimeCardAdd.current.showAddTimeCard(
        this.activeDate
      )
    }
  }

  _onAddTimer () {
    if (this._references.timeItemAdd.current) {
      this._references.timeItemAdd.current.hide()
    }

    const timeCard = {
      userId: app.loggedInId,
      isFavorite: false,
      projectId: null,
      activityId: null,
      taskId: null,
      activity: ''
    }

    const currDate = DateUtil.getUTCCurrentDate()
    this._calculateFromToDates(
      new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate())
    )

    this._reloadData()

    const timer = this._getTimer()
    if (!timer.exists) {
      this._onCreateTimeCard(timeCard, true)
    }
  }

  _onDeleteTimeCardDetail (timeCardId) {
    if (!timeCardId) {
      return false
    }

    // If user task is not there, remove only timecard
    const timer = this._getTimer()
    if (!timer.exists) {
      app.service('/api/timecard').timeout = 15000
      app
        .service('/api/timecard')
        .remove(timeCardId)
        .then(_removeRes => {
          this._references.dialogTimeCardDetail.current.hide()
        })
        .catch(createErr => {
          app.debug('PageTime: _onDeleteTimeCard Error', createErr)
        })

      return
    }

    // Remove timecard and remove timer
    this._removeTimerAndTimeCard(timeCardId, () => {
      if (this._references.dialogTimeCardDetail.current) {
        this._references.dialogTimeCardDetail.current.hide()
      }
    })
  }

  _onUpdateTimeCardDetail (timeCardId, detailObj, bStopTimer) {
    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.hide()
    }

    const timer = this._getTimer()
    TimeUtil.updateTimeCardDetail(timeCardId, detailObj, timer, bStopTimer)
  }

  _onFinalizeTimeCard (timeCardId, detailObj, bStopTimer) {
    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.hide()
    }

    const timer = this._getTimer()
    TimeUtil.updateTimeCardDetail(timeCardId, detailObj, timer, bStopTimer)
    TimeUtil.onCompleteTask(detailObj.taskId)
  }

  _onOpenTimeEditForm (bTimeCard, favItem, callback) {
    const timecard = _.find(this.data.timeCards, timeCardItem => {
      if (
        favItem.projectId !== null &&
        favItem.projectId === timeCardItem.projectId &&
        favItem.activityId !== null &&
        favItem.activityId === timeCardItem.activityId
      ) {
        return timeCardItem
      } else if (
        !favItem.projectId &&
        !favItem.activityId &&
        favItem.customActivityType === timeCardItem.activity
      ) {
        return timeCardItem
      }
    })

    if (!bTimeCard && !timecard) {
      const createData = {
        projectId: favItem.projectId ? favItem.projectId : null,
        activityId: favItem.activityId ? favItem.activityId : null,
        userId: favItem.userId,
        activity: favItem.customActivityType
      }
      this._onCreateTimeCard(createData, false, callback)
    } else {
      const timeCardId = bTimeCard
        ? favItem
        : timecard && timecard.id
          ? timecard.id
          : null

      this.data.editTimeCardId = timeCardId
      this.forceUpdate()
    }
  }

  _onShowDetailForm (timecard) {
    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.show(
        timecard,
        false,
        true,
        true
      )
    }
  }

  _onShowFavouriteDetailForm (favItem) {
    const timecard = _.find(this.data.timeCards, timeCardItem => {
      if (
        favItem.projectId !== null &&
        favItem.projectId === timeCardItem.projectId &&
        favItem.activityId !== null &&
        favItem.activityId === timeCardItem.activityId
      ) {
        return timeCardItem
      } else if (
        !favItem.projectId &&
        !favItem.activityId &&
        favItem.customActivityType === timeCardItem.activity
      ) {
        return timeCardItem
      }
    })

    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.show(
        timecard || favItem,
        false,
        true,
        true
      )
    }
  }

  _onCloseTimeEditForm () {
    this.data.editTimeCardId = null
    this.forceUpdate()
  }

  _onEditFavourite (bEditFavourite) {
    this.data.bEditFavourite = bEditFavourite
    this.setState({ dataDate: new Date() })
  }

  _onCreateTimeCard (timeCardItem, bStartTimer, callback) {
    const timeCard = _.cloneDeep(timeCardItem)
    delete timeCard.favouriteId

    if (timeCard) {
      const filter = this.data.pageState.filter
      timeCard.userId =
        filter.member && filter.member.value
          ? filter.member.value
          : app.loggedInId
      timeCard.createdOn = new Date(this.activeDate)

      const createObj = _.cloneDeep(timeCard)
      const bIsFavorite = createObj.isFavorite
      delete createObj.isFavorite

      TimeUtil.createTimeCard(createObj, createRes => {
        const newTimecardId = createRes.id
        this.data.editTimeCardId = newTimecardId

        if (bStartTimer) {
          this._onTimerStart(createRes)
        }

        if (bIsFavorite) {
          TimeUtil.createFavorite(createRes, null)
        }

        if (callback) {
          callback(createRes)
        }
      })
    }
  }

  _onUpdateFavorite (timecard, bFavorite) {
    const exstFavObj = _.find(this.data.favourites, favItem => {
      if (
        favItem.projectId !== null &&
        favItem.projectId === timecard.projectId &&
        favItem.activityId !== null &&
        favItem.activityId === timecard.activityId
      ) {
        return favItem
      } else if (
        !favItem.projectId &&
        !favItem.activityId &&
        favItem.customActivityType === timecard.activity
      ) {
        return favItem
      }
    })

    if (!exstFavObj || !bFavorite) {
      TimeUtil.updateFavorite(timecard, bFavorite, _updateRes => {
        this._reloadData()
      })
    }
  }

  _onUpdateTimeCard (timecardId, updateObj) {
    app.service('/api/timecard').timeout = 15000
    app
      .service('/api/timecard')
      .patch(timecardId, updateObj)
      .then(_updateRes => {
        this._reloadData()
      })
      .catch(createErr => {
        app.debug('PageTime: _onUpdateTimeCard Error', createErr)
      })
  }

  _onDeleteTimeCard (timecardId) {
    if (!timecardId) {
      return false
    }

    app.service('/api/timecard').timeout = 15000
    app
      .service('/api/timecard')
      .remove(timecardId)
      .then(_removeRes => {
        this._reloadData()
      })
      .catch(createErr => {
        app.debug('PageTime: _onDeleteTimeCard Error', createErr)
      })
  }

  _onDeleteFavourite (favItem) {
    TimeUtil.updateFavorite(favItem, false, () => {
      this._reloadData()
    })
  }

  _onChangeFavouritesOrder (favItems) {
    if (favItems && favItems.length > 0) {
      let orderNumber = 1
      async.map(
        favItems,
        (favTimeCard, mapDone) => {
          TimeUtil.updateFavoriteOrder(
            favTimeCard.id,
            { orderNumber: orderNumber++ },
            mapDone
          )
        },
        (mapErr, _mapRes) => {
          if (mapErr) {
            app.debug('PageTime: _onChangeFavouritesOrder Error', mapErr)
          }
        }
      )
    }
  }

  _onTimerStart (timeCard) {
    this.data.editTimeCardId = null

    // If current task paused update, else create it
    const timer = this._getTimer()
    const timerEvents = buildTimerEvents(app)
    if (timer.doesRelateToTimeCardId(timeCard.id)) {
      timer.resume(app)
    } else {
      if (timer.exists && !timer.ProjectId()) {
        app.service('/api/timecard').timeout = 15000
        app
          .service('/api/timecard')
          .get(timer.TimeCardId(), {})
          .then(result => {
            if (result) {
              const timecard = result

              if (this._references.dialogTimeCardDetail.current) {
                this._references.dialogTimeCardDetail.current.show(
                  timecard,
                  true,
                  false,
                  !timer.TaskId()
                )
              }

              this.data.activeTimeCard = timecard
            }
          })
          .catch(err => {
            app.debug('PageTime: _onTimerStart err', err)
          })
      } else {
        timerEvents.createTimerFromTimeCard(timeCard, app.loggedInId)
      }
    }
  }

  _onTimerPause (timeCard, callback) {
    const timer = this._getTimer()
    if (timer.doesRelateToTimeCardId(timeCard.id)) {
      timer.pause(app)
        .catch(err => app.debug('PageTime: _onTimerPause Error', err))
        .finally(callback)
    }
  }

  _onTimerFinalize (timeCard) {
    // Pause the timer immediately once the stop button is pressed
    this._onTimerPause(timeCard)
    const timer = this._getTimer()

    const showTask = timer.isAssignedToProjectActivity() || !timer.TaskId()
    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.show(
        timeCard,
        true,
        true,
        showTask
      )
    }
  }

  _onTimerStop (timeCard, callback) {
    const timer = this._getTimer()
    if (timer.doesRelateToTimeCardId(timeCard.id)) {
      timer.stop(app)
        .catch(err => app.debug('PageTime: _onTimerStop Error', err))
        .finally(callback)
    }
  }

  _stopAndCreateNewTimeCard (timeCard) {
    if (timeCard.projectId && timeCard.activityId) {
      this._onTimerStop(timeCard, () => {
        // Set the current date
        const currDate = DateUtil.getUTCCurrentDate()
        this.activeDate = new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate()
        )

        timeCard.isFavorite = false
        const createData = Util.removeObjectKeys(_.cloneDeep(timeCard), [
          'id',
          'project',
          'timeTaken',
          'index',
          'activityItem',
          'task'
        ])

        this._onCreateTimeCard(createData, true)
      })
    } else {
      this._onTimerPause(timeCard, () => {
        this._onDeleteTimeCardDetail(timeCard.id)
      })
    }
  }

  _getData (bReload) {
    const { fromDate, toDate, pageState } = this.data

    // Get calendar stats
    let monthStart = moment(this.activeDate)
      .clone()
      .startOf('month')
    monthStart = DateUtil.getMondayByDate(monthStart)
    const monthEnd = moment(monthStart)
      .clone()
      .add(42, 'd')._d

    let projectUserId = app.loggedInId
    if (
      pageState.filter &&
      pageState.filter.member &&
      pageState.filter.member.value
    ) {
      projectUserId = pageState.filter.member.value
    }

    const params = {
      query: {
        pageIdent: this._pageIdent,
        bUpdatePageState: bReload,
        pageState: pageState,
        activeUserId: this.props.activeUserId,
        timecard: {
          userId: app.loggedInId,
          createdOn: {},
          $client: {
            subObjects: {
              project: ['title', 'contactId', 'status'],
              contact: ['company'],
              task: ['title'],
              activityItem: ['noHours', 'percentage'],
              time: true
            }
          },
          $sort: { _id: -1 }
        },
        timecardStat: {
          userId: app.loggedInId,
          activeDate: this.activeDate,
          weekNo: this.weekNo,
          isMobile: false,
          fromDate: fromDate,
          toDate: toDate,
          clientTimezoneOffset: fromDate.getTimezoneOffset()
        },
        favourite: {
          userId: app.loggedInId,
          $sort: { orderNumber: 1 },
          $client: {
            subObjects: {
              project: ['title']
            }
          }
        },
        project: {
          ignoreStatus: ['estimate', 'closed', 'completed'],
          bHasTimeActivity: false,
          filterUserId: projectUserId
        },
        weekstat: {
          fromDate: monthStart,
          toDate: monthEnd,
          userId: app.loggedInId,
          clientTimezoneOffset: fromDate.getTimezoneOffset()
        },
        user: {
          status: 'active'
        }
      }
    }

    const filter = pageState.filter
    if (
      this.props.activeUserId &&
      filter.member &&
      filter.member.value &&
      filter.member.value !== app.loggedInId
    ) {
      params.query.user.userId = pageState.filter.member.value
      params.query.user.$select = ['userId', 'firstName', 'lastName']
      params.query.user.teamId = app.getTeamId()

      filter.member.value = this.props.activeUserId
    }

    if (filter.member) {
      params.query.timecardStat.userId = filter.member.value
      params.query.timecard.userId = filter.member.value
      params.query.weekstat.userId = filter.member.value
    }

    if (this.activeDate) {
      const currDate = this.activeDate
      params.query.timecard.createdOn = {
        $gte: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate()
        ),
        $lt: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate() + 1
        )
      }
    }

    app.service('/api/page/timecard').timeout = 30000
    app
      .service('/api/page/timecard')
      .find(params)
      .then(pageTimecardRes => {
        this._onPageDataRecieved(pageTimecardRes.pageData)

        const options =
          pageTimecardRes.projectOptions.length > 0
            ? pageTimecardRes.projectOptions
            : []
        this.data.favourites = []
        this.data.projects = options
        this.data.weekStats = pageTimecardRes.weekStats || []

        if (pageTimecardRes.stat) {
          this.data.stat = pageTimecardRes.stat
        }

        if (pageTimecardRes.timeCards) {
          // Sort items based on usertask status
          const timer = this._getTimer()
          pageTimecardRes.timeCards.map(timeCard => {
            timeCard.score = 0
            if (timer.doesRelateToTimeCardId(timeCard.id)) {
              timeCard.score = 10
            }
          })

          this.data.timeCards = _.sortBy(pageTimecardRes.timeCards, 'score')
            .reverse()
            .map(obj => {
              delete obj.score
              return obj
            })
        }

        if (pageTimecardRes.favourites) {
          this.data.favourites = pageTimecardRes.favourites
          const favourites = pageTimecardRes.favourites

          if (this.data.timeCards && this.data.timeCards.length > 0) {
            this.data.timeCards.map(timecard => {
              const exstFavObj = _.find(favourites, favItem => {
                if (
                  favItem.projectId !== null &&
                  favItem.projectId === timecard.projectId &&
                  favItem.activityId !== null &&
                  favItem.activityId === timecard.activityId
                ) {
                  return favItem
                } else if (
                  !favItem.projectId &&
                  !favItem.activityId &&
                  favItem.customActivityType === timecard.activity
                ) {
                  return favItem
                }
              })

              if (exstFavObj) {
                timecard.isFavorite = true
              } else {
                timecard.isFavorite = false
              }
            })
          }
        }

        this._onDataReceived(null)
      })
      .catch(err => {
        app.debug('PageTimecard: _getData err', err)
        this._onDataReceived(err)
      })
  }

  _reloadData () {
    this._updatePageState(this.data.pageState)
    this._getData(true)
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        filter: pageState.filter || null
      }
    }
  }

  _getDataTimeCards (callback) {
    const params = {
      query: {
        userId: app.loggedInId,
        createdOn: {},
        $client: {
          subObjects: {
            project: ['title', 'contactId', 'status'],
            contact: ['company'],
            task: ['title'],
            activityItem: ['noHours', 'percentage'],
            time: true
          }
        },
        $sort: { _id: -1 }
      }
    }

    const filter = this.data.pageState.filter
    if (filter.member) {
      params.query.userId = filter.member.value
    }

    if (this.activeDate) {
      const currDate = this.activeDate
      params.query.createdOn = {
        $gte: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate()
        ),
        $lt: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate() + 1
        )
      }
    }

    app.service('/api/timecard').timeout = 15000
    app
      .service('/api/timecard')
      .find(params)
      .then(timeRes => {
        if (timeRes) {
          // Sort items based on usertask status
          const timer = this._getTimer()
          timeRes.data.map(timeCard => {
            timeCard.score = 0
            if (timer.doesRelateToTimeCardId(timeCard.id)) {
              timeCard.score = 10
            }
          })

          this.data.timeCards = _.sortBy(timeRes.data, 'score')
            .reverse()
            .map(obj => {
              delete obj.score
              return obj
            })
        }

        callback(null)
      })
      .catch(timeErr => {
        app.debug('PageTime: _getDataTimeCards Error', timeErr)
        callback(timeErr)
      })
  }

  _getFavourites (callback) {
    this.data.favourites = []

    let favourites = []
    async.series(
      [
        done => {
          const favParams = {
            query: {
              userId: app.loggedInId,
              $sort: { orderNumber: 1 },
              $client: {
                subObjects: {
                  project: ['title']
                }
              }
            }
          }

          app.service('/api/timecard/favorite').timeout = 15000
          app
            .service('/api/timecard/favorite')
            .find(favParams)
            .then(favRes => {
              if (favRes && favRes.total > 0) {
                this.data.favourites = favRes.data
                favourites = favRes.data

                if (this.data.timeCards && this.data.timeCards.length > 0) {
                  this.data.timeCards.map(timecard => {
                    const exstFavObj = _.find(favourites, favItem => {
                      if (
                        favItem.projectId !== null &&
                        favItem.projectId === timecard.projectId &&
                        favItem.activityId !== null &&
                        favItem.activityId === timecard.activityId
                      ) {
                        return favItem
                      } else if (
                        !favItem.projectId &&
                        !favItem.activityId &&
                        favItem.customActivityType === timecard.activity
                      ) {
                        return favItem
                      }
                    })

                    if (exstFavObj) {
                      timecard.isFavorite = true
                    } else {
                      timecard.isFavorite = false
                    }
                  })
                }
              }

              done(null)
            })
            .catch(favErr => {
              app.debug('PageTime: _getFavourites Error', favErr)
              done(favErr)
            })
        }
      ],
      (asynErr, _asyncRes) => {
        if (asynErr) {
          app.debug('Page contact: _onClickSetting err', asynErr)
          callback(asynErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _getDataProjects (callback) {
    let userId = app.loggedInId
    if (
      this.data.pageState.filter &&
      this.data.pageState.filter.member &&
      this.data.pageState.filter.member.value
    ) {
      userId = this.data.pageState.filter.member.value
    }

    this._onTimeProjectSearch(null, true, userId, options => {
      this.data.projects = options
      callback(null)
    })
  }

  _getDataUser (callback) {
    const filter = this.data.pageState.filter
    if (
      this.props.activeUserId &&
      filter.member &&
      filter.member.value &&
      filter.member.value !== app.loggedInId
    ) {
      const params = {
        query: {
          userId: this.data.pageState.filter.member.value,
          $select: ['userId', 'firstName', 'lastName']
        }
      }
      params.query.teamId = app.getTeamId()

      app.service('/api/users/team').timeout = 15000
      app
        .service('/api/users/team')
        .find(params)
        .then(result => {
          if (result.data.length > 0) {
            this.data.pageState.filter.member.label = result.data[0].displayName
            callback(null)
          } else {
            callback(null)
          }
        })
        .catch(err => {
          app.debug('PageTime: _onSearchMember err', err)
          callback(null)
        })
    } else {
      callback(null)
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageTime: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({ loading: true, dataDate: new Date() })
    } else {
      app.debug('PageTime: _onDataReceived [done]')

      const filterUserId =
        this.data.pageState.filter && this.data.pageState.filter.member
          ? this.data.pageState.filter.member.value
          : app.loggedInId

      if (
        this.data.timeCards &&
        this.data.timeCards.length > 0 &&
        (filterUserId === app.loggedInId || Acl.isRoleProjectManager())
      ) {
        if (!this.showFabButton) {
          this._setFABButtonVisible(false)
          this.showFabButton = true
        } else {
          this._setFABButtonVisible(true)
        }
      } else {
        this._setFABButtonVisible(false)
      }

      this.setState({ loading: false, dataDate: new Date() })
    }
  }

  _onSearchMember (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          $or: [
            { firstName: { $regex: pattern, $options: 'i' } },
            { lastName: { $regex: pattern, $options: 'i' } }
          ],
          status: 'active',
          $select: ['userId', 'firstName', 'lastName']
        }
      }
      params.query.teamId = app.getTeamId()

      app.service('/api/users/team').timeout = 15000
      app
        .service('/api/users/team')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(user => ({
              label: user.displayName,
              value: user.userId
            }))
            callback(options)
          } else {
            callback(null, [])
          }
        })
        .catch(err => {
          app.debug('PageTime: _onSearchMember err', err)
          callback(err, [])
        })
    } else {
      callback(null, [])
    }
  }

  /* Private functions */
  _renderAddItem () {
    if (this.data.timeCards.length > 0) {
      const timer = this._getTimer()
      let showAddTimer = true
      const filterUserId =
        this.data.pageState.filter && this.data.pageState.filter.member
          ? this.data.pageState.filter.member.value
          : app.loggedInId

      if (
        filterUserId !== app.loggedInId || (
          timer.isStoppable() &&
          !timer.isAssignedToProjectActivity()
        )
      ) {
        showAddTimer = false
      }

      return (
        <TimeAddItem
          ref={this._references.timeItemAdd}
          showAddTimer={showAddTimer}
          onClose={this._onFABTimeAddClose.bind(this)}
          onAddManualItem={this._onAddManualTimeCard.bind(this)}
          onAddTimerItem={this._onAddTimer.bind(this)}
        />
      )
    }

    return ''
  }

  _onFABTimeAddClose () {
    this._hideCloseFABButton()
  }

  _getItemExists (timecardItems, timecard) {
    const existsObj = _.find(timecardItems, obj => {
      if (timecard.projectId && timecard.activityId) {
        // Project budget activity
        return (
          obj.projectId === timecard.projectId &&
          obj.activityId === timecard.activityId
        )
      }
      /** else { // normal activity - NOT USED SINCE other activity is logged at any time
        return timecard.activity === obj.activity;
      } **/
    })

    return existsObj
  }

  _getWeekStats (fromDate, toDate, callback) {
    const params = {
      query: {
        fromDate: fromDate,
        toDate: toDate,
        userId: app.loggedInId,
        clientTimezoneOffset: fromDate.getTimezoneOffset()
      }
    }

    const filter = this.data.pageState.filter
    if (filter.member) {
      params.query.userId = filter.member.value
    }

    app.service('/api/timecard/weekstat').timeout = 15000
    app
      .service('/api/timecard/weekstat')
      .find(params)
      .then(statRes => {
        callback(statRes.data || [])
      })
      .catch(err => {
        app.debug('PageTime: _getWeekStats ERROR', err)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._initTimerEvents(this._onReloadTimer.bind(this))

    this._eventHandlers.timeCardCreated = this._eventReload.bind(
      this,
      'TimeCard',
      'Created'
    )
    this._eventHandlers.timeCardUpdated = this._eventReload.bind(
      this,
      'TimeCard',
      'Updated'
    )
    this._eventHandlers.timeCardRemoved = this._eventReload.bind(
      this,
      'TimeCard',
      'Removed'
    )
    this._eventHandlers.timeCardPatched = this._eventReload.bind(
      this,
      'TimeCard',
      'Patched'
    )

    const timeCardService = app.service('/api/timecard')
    timeCardService.on('created', this._eventHandlers.timeCardCreated)
    timeCardService.on('updated', this._eventHandlers.timeCardUpdated)
    timeCardService.on('removed', this._eventHandlers.timeCardRemoved)
    timeCardService.on('patched', this._eventHandlers.timeCardPatched)
  }

  _releaseEvents () {
    this._releaseTimerEvents()

    const timeCardService = app.service('/api/timecard')
    timeCardService.off('created', this._eventHandlers.timeCardCreated)
    timeCardService.off('updated', this._eventHandlers.timeCardUpdated)
    timeCardService.off('removed', this._eventHandlers.timeCardRemoved)
    timeCardService.off('patched', this._eventHandlers.timeCardPatched)

    this._eventHandlers.timeCardCreated = null
    this._eventHandlers.timeCardUpdated = null
    this._eventHandlers.timeCardRemoved = null
    this._eventHandlers.timeCardPatched = null
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()

      if (this.data.activeTimeCard) {
        const timer = this._getTimer()
        const timerEvents = buildTimerEvents(app)
        const timeCard = this.data.activeTimeCard
        if (timer.doesRelateToTimeCardId(timeCard.id)) {
          timer.resume(app)
        } else {
          timerEvents.createTimerFromTimeCard(timeCard, app.loggedInId)
        }
        this.data.activeTimeCard = null
      }
    }
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageTime - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _updateWeekNo (activeDate) {
    if (activeDate.getDay() === 0) {
      const date = DateUtil.addDaysToDate(activeDate, -1)
      this.weekNo = DateUtil.getLocalWeekNo(date)
      this.year = date.getFullYear()
    } else {
      this.weekNo = DateUtil.getLocalWeekNo(activeDate)
      this.year = activeDate.getFullYear()
    }
  }

  _calculateFromToDates (activeDate) {
    this.activeDate = activeDate

    this.data.fromDate = DateUtil.getMondayByDate(activeDate)
    this.data.toDate = DateUtil.addDaysToDate(this.data.fromDate, 6)
    this.data.toDate.setHours(23, 59, 59, 59)
  }

  /* Header Functions - START */
  renderHeader () {
    const {
      userName,
      pageState,
      fromDate,
      toDate,
      weekStats,
      favourites,
      bEditFavourite
    } = this.data
    const weekNo = DateUtil.getDisplayWeek(fromDate)
    const { member } = pageState.filter || {}
    const isMemberSelected = member && member.label
    const filter = pageState.filter
    let bCurUser = true

    if (filter.member && filter.member.value !== app.loggedInId) {
      bCurUser = false
    }

    const timer = this._getTimer()

    const stat = this.data.stat || { totalHours: 0, openHours: 0, days: [] }
    const isOverDue = stat.totalHours < 0

    if (!userName) {
      return null
    }

    const filters = [
      {
        ident: 'member',
        type: 'tag',
        label: 'project.list.filterAllTeamMembers',
        placeholder: 'project.list.searchTeamMember',
        isMulti: false,
        value: member || null
      }
    ]
    const actions = [
      {
        ident: 'previous',
        icon: 'arrow-left',
        tooltip: 'time.form.tipPreviousweek',
        tooltipPosition: 'bottomleft',
        onClick: this._onHeaderNavigateWeek.bind(this, -1)
      },
      {
        ident: 'next',
        icon: 'arrow-right',
        tooltip: 'time.form.tipNextweek',
        tooltipPosition: 'bottom',
        onClick: this._onHeaderNavigateWeek.bind(this, 1)
      },
      {
        ident: 'date',
        icon: 'planner',
        tooltip: 'time.form.tipDatePick',
        tooltipPosition: 'bottom',
        onClick: this._onHeaderCalendarOpen.bind(this)
      }
    ]

    if (!stat) {
      return null
    }

    const statInfos = []
    const statDays = stat.days || []

    statDays.forEach(day => {
      day.date = new Date(day.date)

      statInfos.push({
        title: `${DateUtil.getDisplayWeekDay(day.date).substr(
          0,
          3
        )} ${day.date.getDate()} ${DateUtil.getDisplayMonth(day.date)}`,
        isMultilingual: false,
        options: [
          {
            type: 'number',
            value: Util.convertMinutesToHour(day.timeTaken || 0),
            active: true
          },
          {
            type: 'splitter'
          },
          {
            type: 'number',
            value: Util.convertMinutesToHour(day.timeTotal || 0)
          },
          {
            type: 'label',
            value: IntlUtil.convertMessage('time.header.labelHours')
          }
        ],
        active: DateUtil.isDateEqual(day.date, this.activeDate),
        onClick: this._onHeaderChangeDate.bind(this, new Date(day.date))
      })
    })

    const weekHighlightInfo = {}
    if (weekStats) {
      let className = ''

      weekStats.forEach(weekObj => {
        if (weekObj && weekObj.percentage !== null) {
          if (weekObj.percentage >= 100) {
            className = ' success'
          } else if (weekObj.percentage <= 0) {
            className = ' error'
          } else {
            className = ' warning'
          }

          weekHighlightInfo[`${weekObj.year}-${weekObj.weekNo}`] = className
        }
      })
    }

    return (
      <div className='pagetime-headerwrap'>
        <PageHeaderTime
          title={`${IntlUtil.convertMessage('time.list.weekTitle')} ${weekNo}`}
          subtitle={`${IntlUtil.convertMessage(
            'time.list.labelFrom'
          )} ${DateUtil.getDisplayDate(fromDate)} ${IntlUtil.convertMessage(
            'time.list.labelTo'
          )} ${DateUtil.getDisplayDate(toDate)}`}
          isTitleMultilingual={false}
          icon={<TimeIcon width={25} />}
          statInfos={statInfos}
          actions={actions}
          alignActions='left'
          alignStatInfos='bottom'
          userName={isMemberSelected ? member.label : userName}
          isDefaultUser={!isMemberSelected}
          canChangeUser={!Acl.isStandardUser()}
          filters={filters}
          totalHours={stat.totalHours}
          openHours={stat.openHours}
          isOverDue={isOverDue}
          onSearchTags={this._onHeaderSearchTags.bind(this)}
          onChange={this._onHeaderChangeFilter.bind(this)}
        />
        <DateRangePicker
          ref={this._references.pageHeaderCalendar}
          placeholder='time.header.calendar'
          name='date'
          isSingleDate
          startDate={this.activeDate}
          endDate={null}
          weekHighlightInfo={weekHighlightInfo}
          onSelect={this._onHeaderChangeDate.bind(this)}
        />
        {favourites.length > 0 && (
          <FavouriteList
            timeCards={favourites}
            currentUser={bCurUser}
            showEdit={bEditFavourite}
            onDelete={this._onDeleteFavourite.bind(this)}
            timer={timer}
            onOpenForm={this._onOpenTimeEditForm.bind(this, false)}
            activeDate={this.activeDate}
            onShowDetailForm={this._onShowFavouriteDetailForm.bind(this)}
            onChangeOrder={this._onChangeFavouritesOrder.bind(this)}
            onCreateTimeCard={this._onCreateTimeCard.bind(this)}
            onClickEdit={this._onEditFavourite.bind(this)}
          />
        )}
      </div>
    )
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'member') {
      this._onSearchMember(keyword, callback)
    }
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderNavigateWeek (incr) {
    this._calculateFromToDates(
      DateUtil.addDaysToDate(this.activeDate, incr * 7)
    )

    this._reloadData()

    if (this._references.timeItemAdd.current) {
      this._references.timeItemAdd.current.hide()
    }
  }

  _onHeaderCalendarOpen () {
    if (this._references.pageHeaderCalendar.current) {
      this._references.pageHeaderCalendar.current.show()
    }
  }

  _onHeaderChangeDate (date) {
    this._calculateFromToDates(date)

    this._reloadData()

    if (this._references.timeItemAdd.current) {
      this._references.timeItemAdd.current.hide()
    }
  }
  /* Header Functions - END */
}

export default PageTime
